import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerBank = createAsyncThunk(
  "sellerBank/SellerBank",
  async (data, thunkAPI) => {
    const datas = {
      accountHolderName: data?.accountHolderName,
      bankName: data?.bankName,
      accountNumber: data?.accountNumber,
      pincode: data?.pincode,
      ifsc: data?.ifsc,
      branchName: data?.branchName,
      accountType: data?.accountType,
    };
    try {
      const SellerId = localStorage.getItem("SellerloginData");
      const response = await axios.post(
        `${endPoint.SellerBankDetails}/${SellerId}`,
        datas
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SelleBankSlice = createSlice({
  name: "SellerBankData",
  initialState: {
    SellerBankData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerBank.fulfilled, (state, action) => {
        state.SellerBankData = action.payload;
      })
      .addCase(SellerBank.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SelleBankSlice.reducer;
